class VliscoWishlist {
    constructor() {
        this.classes = {
            active: 'active',
            loading: 'loading',
            wishlist: 'vlisco-cart__wishlist',
            tab: 'vlisco-cart__tab--wishlist',
            counter: 'vlisco-cart__counter--wishlist',
            template: 'vlisco-cart__wishlist-template',
            container: 'vlisco-cart__wishlist-container',
            removeBtn: 'vlisco-cart__wishlist-button--remove',
            addToCartBtn: 'vlisco-cart__wishlist-button--add-to-cart',
        };

        this.init();
    }

    init() {
        window.SwymCallbacks = window.SwymCallbacks || [];
        this.tab = document.querySelector(`.${ this.classes.tab }`);
        this.wishlist = document.querySelector(`.${ this.classes.wishlist }`);
        this.template = document.querySelector(`.${ this.classes.template }`);
        this.counters = document.querySelectorAll(`.${ this.classes.counter }`);
        this.container = document.querySelector(`.${ this.classes.container }`);
        

        window.SwymCallbacks.push(this.renderWishlist.bind(this))
        window.SwymCallbacks.push(() => {
            window._swat.evtLayer.addEventListener('sw:addedtowishlist', (prodData) => {
                this.renderWishlist();

                this.addGTMEvent(prodData);
            });
        });

        document.addEventListener('update-wishlist', () => this.renderWishlist());
        document.addEventListener('open-wishlist', e => {
            e.preventDefault();

            this.tab.click();
            document.dispatchEvent(new CustomEvent('open-cart'));
        });
    }

    toggleLoader(state) {
        this.wishlist.classList[state ? 'add' : 'remove'](this.classes.loading);
    }

    async renderWishlist() {
        const swat = window._swat;
        const { items } = await this.getCart();

        swat.fetch(products => {
            this.counters.forEach(counter => {
                if (counter.classList.contains('trigger')) {
                    counter.innerHTML = products.length == 0 ? '' : products.length;
                } else {
                    counter.innerHTML = products.length;
                }
            });

            if (!products.length) {
                this.container.innerHTML = '';
                this.toggleLoader(false);

                return;
            }

            const formattedProducts = products.map(product => {
                product = window.SwymUtils.formatProductPrice(product);

                let formattedProduct = {
                    is_in_cart: items.filter(({ id }) => id === product.epi).length,
                    final_price: product.pr + ' ' + window.Shopify.currency.active,
                    variant_info: product.vi,
                    product_id: product.empi,
                    variant_id: product.epi,
                    title: product.dt,
                    link: product.du,
                    src: `${this.cdn}${productUrl}`
                };

                return formattedProduct;
            });

            const markup = window.SwymUtils.renderTemplateString(this.template.innerHTML, { products: formattedProducts });

            this.container.innerHTML = markup;

            this.updateImageSrc();
            this.eventListener();
            this.toggleLoader(false);
        });
    }

    updateImageSrc() {
        this.container.querySelectorAll('.vlisco-cart__wishlist-image').forEach((img) => {
            img.src = img.dataset.src;
        })
    }

    eventListener() {
        this.removeButtons = document.querySelectorAll(`.${ this.classes.removeBtn }`);
        this.addToCartButtons = document.querySelectorAll(`.${ this.classes.addToCartBtn }`);

        this.removeButtons.forEach(removeBtn => {
            removeBtn.addEventListener('click', event => {
                event.preventDefault();

                this.remove(removeBtn.dataset.variantId, removeBtn.dataset.productId);
            });
        });

        this.addToCartButtons.forEach(addToCartBtn => {
            addToCartBtn.addEventListener('click', event => {
                event.preventDefault();

                this.addToCart(addToCartBtn.dataset.variantId, addToCartBtn.dataset.productId, addToCartBtn.dataset.link);
            });
        });
    }

    addToCart(variantId, productId, link) {
        if (!variantId || !productId || !link) return;

        this.toggleLoader(true);

        window._swat.replayAddToCart(
            { empi: productId, du: link },
            variantId,
            (response) => {
                document.dispatchEvent(new CustomEvent('update-cart', {
                    detail: {
                        cartLine: 1,
                        response: JSON.parse(response).items[0]
                    }
                }));

                this.renderWishlist();
            },
            error => {
                console.log(`Wishlist Add to Cart: ${ error }`);
                this.toggleLoader(false);
            }
        );
    }

    remove(variantId, productId) {
        if (!variantId || !productId) return;

        this.toggleLoader(true);

        window._swat.fetch(products => {
            products.forEach(product => {
                if (product.epi == variantId && product.empi == productId) {
                    window._swat.removeFromWishList(product, () => {
                        window.SwymCallbacks = window.SwymCallbacks || [];
                        window.SwymCallbacks.push(this.renderWishlist.bind(this));
                    });
                }
            });
        });
    }

    async getCart() {
        const response = await fetch('/cart.js');

        return await response.json();
    }

    addGTMEvent(prodData) {
        const dataLayer = window.dataLayer || [];
        const data = prodData.detail.d
        const parts = data.dt.split(' | ');

        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "add_to_wishlist",
            ecommerce: {
                currency: ShopifyAnalytics.meta.currency,
                value: `${data.pr}`,
                items: [
                    {
                        item_id: `${parts[1]}`,
                        item_name: `${parts[1]}`,
                        item_category: `${parts[0]}`,
                        item_list_id: "category",
                        item_list_name: "Category Overview",
                        item_variant: `${data.sku}`,
                        price: `${data.pr}`,
                        quantity: 1
                    }
                ]
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => new VliscoWishlist());
